module.exports = __webpack_public_path__ + "media/customizations/regencyatnorthskye/logo-new-1edfb07e48ced5cd13b5766d36dbfe03.png";